import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { RadioButton } from 'primereact/radiobutton';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import OptionValidator from '../FormComponenets/OptionValidator';

export default function SingleChoice({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, required, options = [], label = 'Short Text' } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex flex-row align-items-start flex-wrap">
        <div className="w-100 d-flex flex-row align-items-start flex-wrap">
          <Controller
            name={name}
            control={control}
            rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
            render={({ field, fieldState }) => (
              <>
                {options.map((option, i) => (
                  <div key={option.value} className="d-flex w-50 p-field-checkbox mt-2 cursor-pointer">
                    <RadioButton
                      id={name}
                      inputId={name + i}
                      value={option.value}
                      onChange={(e) => field.onChange(e.value)}
                      checked={field.value === option.value}
                      className={classNames({ 'p-invalid': fieldState.invalid })}
                      style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
                      disabled={isFormBuilder}
                      inputRef={isFormBuilder ? null : field.ref}
                    />
                    <label htmlFor={name + i} className="ms-1 cursor-pointer p-checkbox-label">
                      {option.label}
                    </label>
                  </div>
                ))}
              </>
            )}
          />
        </div>
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
        {isFormBuilder && item?.res_type !== 'custom-field' && (
          <span className="add-option" onClick={() => handleSettingsClick(item)}>
            + Add Options
          </span>
        )}
        {isFormBuilder && item?.res_type !== 'custom-field' && <OptionValidator name={`form_data.${index}.options`} />}
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
